/* eslint-disable import/prefer-default-export */
import cryptoJs from 'crypto-js';

export const encrypt = (key, data) => {
  const encryptedJs = cryptoJs.AES.encrypt(data, key).toString();
  return encryptedJs;
};
